/** État de l'emprunt de compte (claim `imp` du jeton Directus courant). */
export const useImpersonation = () => {
  const { token } = useDirectusToken()

  const claim = computed<{ imp: string, exp?: number } | null>(() => {
    if (!token.value) return null
    try {
      const segment = token.value.split('.')[1] || ''
      const payload = JSON.parse(atob(segment.replace(/-/g, '+').replace(/_/g, '/')))
      return typeof payload?.imp === 'string' ? { imp: payload.imp, exp: payload.exp } : null
    }
    catch {
      return null
    }
  })

  const isImpersonating = computed(() => Boolean(claim.value))
  const expiresAt = computed(() => (claim.value?.exp ? new Date(claim.value.exp * 1000) : null))

  const stop = async () => {
    await $fetch('/api/impersonation/stop', { method: 'POST' }).catch(() => null)
    useUserStore().logout()
    // Rechargement complet : repart d'un état Nuxt/Pinia propre pour l'administrateur
    window.location.href = '/volontaires/admin/utilisateurs'
  }

  return { isImpersonating, expiresAt, stop }
}
